<div class="building-selection-title">
	<div class="icon-wrapper">
		<mat-icon svgIcon="robot" />
	</div>
	<h3>{{ 'chatbot_title' | translate }}</h3>
</div>
<p class="building-selection-text body-2 grey">
	{{ 'chatbot_welcome_msg' | translate }}
</p>
<div class="building-selection-selector">
	<mat-form-field hideRequiredMarker>
		<mat-label>{{ 'building' | translate }}</mat-label>
		<mat-select
			[formControl]="buildingControl"
			[placeholder]="'choose_building' | translate"
			(selectionChange)="onBuildingChange($event)"
		>
			@for (building of buildings(); track building.id) {
				<mat-option [value]="building.id">
					<span>{{ building.name }}</span>
				</mat-option>
			}
		</mat-select>
	</mat-form-field>
</div>
